/* dcl-your-price.js  (rev 2, 2026-10-21)
 * 2026-10-21: Lake is switched off. Lake has not published a MAP policy and objected
 *   to a discounted price on the MX242, so the Lake discount shows only in the cart.
 *   To turn the Lake on-page price back on, delete the Lake guard below.
 * Dialed Cycling Lab. Shows the shopper their discounted price on a product
 * page after they apply a brand popup code. Jake's call (2026-10-03): only the
 * shopper who applied the code sees it. Crawlers, Google Shopping, and anyone
 * without the code see the regular price. Garmin has its own copy of this
 * logic inside dcl-garmin-offer.js (built first); this file serves Lake,
 * Silca, Kask, SRAM, and Wahoo.
 *
 * CONFIG comes from theme.liquid, one brand per page:
 *   window.DCL_YOUR_PRICE = { code, brand, pct, inScope }
 *   - inScope mirrors the rules of the "<Brand> - Discount Eligible (Full
 *     Price)" collection the code is limited to. Keep them in step.
 *   - pct is shop metafield dcl.<brand>_offer_pct. KEEP IT EQUAL TO THE CODE'S
 *     PERCENTAGE, or the page shows a price the cart will not charge.
 *
 * WHEN IT SHOWS, all required:
 *   - inScope is true and pct is between 1 and 99
 *   - the code is applied: Shopify's discount_code cookie equals it, or the
 *     cart lists it (a second brand code replaces the cookie but both stay on
 *     the cart, so both brands keep showing)
 *   - the selected variant is not marked down (compare_at_price <= price)
 *
 * MATH matches Shopify's line discount exactly: price minus
 * floor(price * pct / 100) in cents. Shopify rounds the discount down
 * (verified in a real cart on 2026-10-03).
 *
 * The theme redraws the price block on variant change, and updates the hidden
 * variant field after it, so this re-checks on change and polls cheaply.
 * Timers, not requestAnimationFrame, because rAF pauses in background tabs.
 */
(function () {
  'use strict';
  if (window.__dclYourPrice) return;
  window.__dclYourPrice = true;

  var cfg = window.DCL_YOUR_PRICE;
  if (!cfg || !cfg.inScope || !cfg.code) return;
  if (String(cfg.brand || '').toLowerCase() === 'lake') return; // 2026-10-21: Lake shows its discount in the cart only
  var pct = Number(cfg.pct) || 0;
  if (!(pct > 0 && pct < 100)) return;

  var CODE = String(cfg.code).toUpperCase();
  var BRAND = cfg.brand || 'brand';

  var path = window.location.pathname;
  var at = path.indexOf('/products/');
  if (at < 0) return;
  var handle = path.slice(at + 10).split('/')[0];
  if (!handle) return;

  function cookieHasCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    try { return decodeURIComponent(m[1]).toUpperCase() === CODE; } catch (e) { return false; }
  }

  function cartHasCode(cb) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        var codes = (c && c.discount_codes) || [];
        for (var i = 0; i < codes.length; i++) {
          if (String(codes[i].code || '').toUpperCase() === CODE) return cb(true);
        }
        cb(false);
      })
      .catch(function () { cb(false); });
  }

  function injectStyles() {
    if (document.getElementById('dcl-yp-styles')) return;
    var s = document.createElement('style');
    s.id = 'dcl-yp-styles';
    s.textContent =
      '.dcl-yp-struck .f-price-item--regular{text-decoration:line-through;opacity:.55}' +
      '.dcl-yp{display:flex;flex-wrap:wrap;align-items:baseline;gap:.25rem .6rem;margin:.5rem 0 .25rem}' +
      '.dcl-yp__label{color:#e42e0f;font-size:.85rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase}' +
      '.dcl-yp__amt{color:#e42e0f;font-size:1.6rem;font-weight:800;line-height:1.1}' +
      '.dcl-yp__note{flex-basis:100%;font-size:.9rem;opacity:.8}';
    document.head.appendChild(s);
  }

  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var product = null;
  var pending = false;
  var lastKey = '';

  function priceBox() { return document.querySelector('[id^="price-"][id$="__main"]'); }

  function variantId() {
    var info = document.querySelector('[id^="ProductInfo-"][id$="__main"]') || document;
    var input = info.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    var v = input && input.value;
    if (!v) v = new URLSearchParams(window.location.search).get('variant');
    return v ? Number(v) : null;
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'dcl-yp';
    el.setAttribute('aria-live', 'polite');
    var label = document.createElement('span');
    label.className = 'dcl-yp__label';
    label.textContent = 'Your price';
    var amt = document.createElement('span');
    amt.className = 'dcl-yp__amt';
    var note = document.createElement('span');
    note.className = 'dcl-yp__note';
    note.textContent = 'Your ' + BRAND + " discount is applied. You'll see it in your cart.";
    el.appendChild(label);
    el.appendChild(amt);
    el.appendChild(note);
    return el;
  }

  function render() {
    pending = false;
    var box = priceBox();
    if (!box || !product) return;
    var id = variantId();
    var v = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) { v = product.variants[i]; break; }
    }
    if (!v) v = product.variants[0];
    lastKey = String(v.id);
    var el = document.querySelector('.dcl-yp');
    var reduced = v.compare_at_price && v.compare_at_price > v.price;
    if (reduced) {
      if (el) el.parentNode.removeChild(el);
      if (box.classList.contains('dcl-yp-struck')) box.classList.remove('dcl-yp-struck');
      return;
    }
    var cents = v.price - Math.floor(v.price * pct / 100);
    var text = money.format(cents / 100);
    if (!box.classList.contains('dcl-yp-struck')) box.classList.add('dcl-yp-struck');
    if (!el) el = build();
    if (el.previousElementSibling !== box) box.insertAdjacentElement('afterend', el);
    var amt = el.querySelector('.dcl-yp__amt');
    if (amt.textContent !== text) amt.textContent = text;
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(render, 30);
  }

  function run() {
    injectStyles();
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        product = p;
        render();
        document.addEventListener('change', function () {
          setTimeout(schedule, 60); setTimeout(schedule, 300); setTimeout(schedule, 900);
        });
        setInterval(function () {
          var id = variantId();
          var box = priceBox();
          if ((id && String(id) !== lastKey) ||
              (box && !box.classList.contains('dcl-yp-struck') && document.querySelector('.dcl-yp'))) schedule();
        }, 500);
      })
      .catch(function () {});
  }

  if (cookieHasCode()) run();
  else cartHasCode(function (on) { if (on) run(); });
})();
